// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.redMap {
  background-color: rgb(207, 113, 112);
}
.orangeMap{
  background-color: rgb(228, 195, 129);
}
.greenMap{
  background-color: rgb(194, 222, 147);
}
.workingMap{
  background-color: lightgray;
}

.borderless td, .borderless th {
  border: none;
}

.padTop {
 padding-top: 10px;
}

.padLeft {
  padding-left: 10px;
 }

.cardTitleP {
  padding-left: 20px;
}

.paddingButton {
  padding-left: 40px;
}

.settingsInputSize {
  width: 10%;
}

.form-control{
  box-shadow: none;
}

.btn{
  box-shadow: none;
}



.myBtn{
  width: 5em;
}
.modal-content {
  /* 80% of window height */
  height: 80%;
}
.heightOverflow{
  height: 60px;
}

.tableFont{
  font-size: 10px;
}
/* v primeru, da gledamo preko tablice pa do telefon */
@media (max-width: 991.98px) {
  .body {
    font-size: 8px;
  }

  .mobileHide {
    visibility: hidden;
    display: none;
  }

  .mobile{
    margin: 0;
    padding-right: 0;
    padding-left: 0;

    padding-top: 0%;
    padding-bottom: 0%;
  }
  .mobileLeft {
    padding-top: 0%;
    padding-bottom: 0%;
  }

  .mobileRight {
    float: right;
    padding-top: 0%;
    padding-bottom: 0%;
  }


  .mobileTdShort {
    padding-left: 0%;
    width: 40px;
  }

  .mobileTdShortest {
    width: 50px;
  }

  .mobileTdbig {
    padding-left: 0%;
    width: 60px;
  }
  .mobileTdLong {
    padding-left: 0%;
    width: 200px;
  }
}

@media (max-width: 431.98px) {


  .mobilePadding {
    padding-top: 10px;
  }
}

table {
  table-layout: fixed;
  width: 100%;
}


td {
  font-size: 20px;
}

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

#overlayNoWhite {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 35%;
  opacity: .80;
}

@media (min-width: 450px){
  .tableDesktop {
    width:25%;
  }

  .tableDesktopShort {
    width: 50px;
  }

  .tableDesktopBig {
    width: 200px;
  }
  .table100px {
    width: 100px;
  }
}

.card-columns {

    -moz-column-count: 4;

         column-count: 4;

}
.tableBottomBorder {
  border-top: hidden;
  border-right: hidden;
  border-left: hidden;
  border-bottom-style: solid !important;
  border-bottom-color: black !important;
}

.trNoWhiteBorder {
  border: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/monitor/monitor.component.css"],"names":[],"mappings":";AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;EACE,kBAAkB;CACnB;;AAED;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA,sDAAsD;AACtD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;;IAEf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;;;EAGE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;;IAEI,oBAAe;;SAAf,eAAe;;AAEnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["\n.redMap {\n  background-color: rgb(207, 113, 112);\n}\n.orangeMap{\n  background-color: rgb(228, 195, 129);\n}\n.greenMap{\n  background-color: rgb(194, 222, 147);\n}\n.workingMap{\n  background-color: lightgray;\n}\n\n.borderless td, .borderless th {\n  border: none;\n}\n\n.padTop {\n padding-top: 10px;\n}\n\n.padLeft {\n  padding-left: 10px;\n }\n\n.cardTitleP {\n  padding-left: 20px;\n}\n\n.paddingButton {\n  padding-left: 40px;\n}\n\n.settingsInputSize {\n  width: 10%;\n}\n\n.form-control{\n  box-shadow: none;\n}\n\n.btn{\n  box-shadow: none;\n}\n\n\n\n.myBtn{\n  width: 5em;\n}\n.modal-content {\n  /* 80% of window height */\n  height: 80%;\n}\n.heightOverflow{\n  height: 60px;\n}\n\n.tableFont{\n  font-size: 10px;\n}\n/* v primeru, da gledamo preko tablice pa do telefon */\n@media (max-width: 991.98px) {\n  .body {\n    font-size: 8px;\n  }\n\n  .mobileHide {\n    visibility: hidden;\n    display: none;\n  }\n\n  .mobile{\n    margin: 0;\n    padding-right: 0;\n    padding-left: 0;\n\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n  .mobileLeft {\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n  .mobileRight {\n    float: right;\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n\n  .mobileTdShort {\n    padding-left: 0%;\n    width: 40px;\n  }\n\n  .mobileTdShortest {\n    width: 50px;\n  }\n\n  .mobileTdbig {\n    padding-left: 0%;\n    width: 60px;\n  }\n  .mobileTdLong {\n    padding-left: 0%;\n    width: 200px;\n  }\n}\n\n@media (max-width: 431.98px) {\n\n\n  .mobilePadding {\n    padding-top: 10px;\n  }\n}\n\ntable {\n  table-layout: fixed;\n  width: 100%;\n}\n\n\ntd {\n  font-size: 20px;\n}\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n#overlayNoWhite {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 35%;\n  opacity: .80;\n}\n\n@media (min-width: 450px){\n  .tableDesktop {\n    width:25%;\n  }\n\n  .tableDesktopShort {\n    width: 50px;\n  }\n\n  .tableDesktopBig {\n    width: 200px;\n  }\n  .table100px {\n    width: 100px;\n  }\n}\n\n.card-columns {\n\n    column-count: 4;\n\n}\n.tableBottomBorder {\n  border-top: hidden;\n  border-right: hidden;\n  border-left: hidden;\n  border-bottom-style: solid !important;\n  border-bottom-color: black !important;\n}\n\n.trNoWhiteBorder {\n  border: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
